import axios from "axios";

const api = axios.create({
  baseURL: "https://grupopneusbrasil.ddns.net:8162/rest/",
  headers: {
    "Content-type": "application/json",
    Accept: "application/vnd.github+json",
  },
});

export default api;
